import { createSlice, createAction } from '@reduxjs/toolkit'

import { mappingAdminData } from 'utils/mappingAdminProfileForFilter'

const initialState = {
  isFetching: false,
  isFetchingUpdates: false,
  isFetchingMeterUpdate: false,
  isSuccessUpdates: false,
  isFailedUpdates: false,
  devicesList: [],
  error: '',
  panelList: {
    panels: [],
    meter_types: [],
  },
  adminProfileData: {
    users: [],
  },
  isFetchingAdminProfile: false,
}

export const getAdminProfileDataSelector = (state) =>
  mappingAdminData(state.devices.adminProfileData.users)
export const getIsFetchingAdminProfileSelector = (state) =>
  state.devices.isFetchingAdminProfile

export const getPanelByIdSelector = (id) => (state) =>
  state.devices.panelList.panels.find((panel) => panel.id === id)

export const getPanelMeterTypesSelector = (state) => {
  return state.devices.panelList.meter_types.map((meter) => ({
    id: meter.id,
    label: `Type: ${meter.name}`,
    value: meter,
  }))
}
export const getIsFetchingMeterUpdateSelector = (state) =>
  state.devices.isFetchingMeterUpdate
export const getPanelListSelector = (state) => state.devices.panelList.panels
export const getDevicesListSelector = (state) => state.devices.devicesList
export const getIsfetchingDevicesSelector = (state) => state.devices.isFetching
export const getIsFetchingUpdateSelector = (state) =>
  state.devices.isFetchingUpdates
export const getIsSuccessUpdatesSelector = (state) =>
  state.devices.isSuccessUpdates
export const getUpdatesStateSelecor = (state) => ({
  isFetchingUpdates: state.devices.isFetchingUpdates,
  isSuccessUpdates: state.devices.isSuccessUpdates,
  isFailedUpdates: state.devices.isFailedUpdates,
})

const devicesSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    loadingDevices(state) {
      state.isFetching = true
    },
    loadingDevicesSuccess(state, action) {
      state.devicesList = action.payload
      state.isFetching = false
      state.error = ''
    },
    loadindFailed(state, action) {
      state.devicesList = []
      state.isFetching = false
      state.error = action.payload
    },
    deleteDevices(state) {
      state.isFetchingUpdates = true
    },
    successUpdates(state) {
      state.isFetchingUpdates = false
      state.isSuccessUpdates = true
    },
    failedUpdates(state) {
      state.isFetchingUpdates = false
      state.isFailedUpdates = true
    },
    updateDevices(state) {
      state.isFetchingUpdates = true
    },
    createDevices(state) {
      state.isFetchingUpdates = true
    },
    clearUpdatesState(state) {
      state.isFailedUpdates = false
      state.isSuccessUpdates = false
    },
    loadingPanel(state) {
      state.isFetching = true
    },
    loadingPanelSuccess(state, action) {
      state.panelList = action.payload
      state.isFetching = false
      state.error = ''
    },
    loadindPanelFailed(state, action) {
      state.panelList = []
      state.isFetching = false
      state.error = action.payload
    },
    successUpdatesPanel(state, action) {
      state.isFetchingUpdates = false
      state.isSuccessUpdates = true
      state.panelList.panels = action.payload
    },
    failedUpdatesPanel(state) {
      state.isFetchingUpdates = false
    },
    updatePanel(state) {
      state.isFetchingUpdates = true
    },
    addMeter(state) {
      state.isFetchingMeterUpdate = true
    },
    addMeterSuccess(state, action) {
      state.isFetchingMeterUpdate = false
      state.panelList.panels = action.payload
    },
    addMeterFailed(state) {
      state.isFetchingMeterUpdate = false
    },
    setAdminProfile(state, action) {
      state.adminProfileData = action.payload
    },
    setIsFetchingAdminProfile(state, action) {
      state.isFetchingAdminProfile = action.payload
    },
  },
})

export const getAdminProfile = createAction('devices/getAdminProfile')

export const {
  loadindFailed,
  loadingDevicesSuccess,
  loadingDevices,
  deleteDevices,
  updateDevices,
  createDevices,
  successUpdates,
  failedUpdates,
  clearUpdatesState,
  loadindPanelFailed,
  loadingPanel,
  loadingPanelSuccess,
  updatePanel,
  failedUpdatesPanel,
  successUpdatesPanel,
  addMeter,
  addMeterFailed,
  addMeterSuccess,
  setAdminProfile,
  setIsFetchingAdminProfile,
} = devicesSlice.actions

export default devicesSlice.reducer
